import React, { Component, Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import H3Text from '@Uilib/h3Text';
import InventoryLocationActions from '@Actions/settings/inventoryLocationActions';
import './style.scss';
import PRZSelect from '../../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
function WarehouseLocationSelector({
  inventoryLocations, destDepartmentId, selectedInventoryLocation, getInventoryLocationsLoading, onChange,
  disabled, showError, title, hideTitle, containerClassName, inputClassName, labelClassName, user,
  getInventoryLocations,
}) {
  useEffect(() => {
    const deptId = destDepartmentId || user?.tenant_info?.default_store_id;
    if (!(inventoryLocations?.inventory_location?.[0]?.tenant_department_id === deptId) && !getInventoryLocationsLoading) {
      getInventoryLocations(destDepartmentId || user?.tenant_info?.default_store_id, '', null, true);
    }
  }, [destDepartmentId]);
  return (
    <div className={containerClassName}>
      {!hideTitle && <H3Text text={title || 'Select Put Away Location'} required className={labelClassName} />}
      <PRZSelect
        value={selectedInventoryLocation}
        disabled={getInventoryLocationsLoading || disabled}
        loading={getInventoryLocationsLoading}
        filterOption={false}
        showSearch
        className={inputClassName}
        onChange={(value) => {
          onChange(value, inventoryLocations?.inventory_location?.find((item) => item.inventory_location_id == value)?.inventory_location_path);
        }}
        onSearch={(keyword) => {
          getInventoryLocations(destDepartmentId || user?.tenant_info?.default_store_id, keyword, null, true);
        }}
        placeholder=""
      >
        {
            inventoryLocations?.inventory_location?.filter((item) => item?.is_active)?.map((item) => (
              <Option
                key={item?.inventory_location_id}
                value={item?.inventory_location_id}
                title={item?.inventory_location_path}
              >
                <H3Text text={item?.inventory_location_path} className="create-new-batch__location-item" />
              </Option>
            ))
        }
      </PRZSelect>
    </div>

  );
}

const mapStateToProps = ({ UserReducers, InventoryLocationReducers }) => ({
  user: UserReducers.user,
  getInventoryLocationsLoading: InventoryLocationReducers.getInventoryLocationsLoading,
  inventoryLocations: InventoryLocationReducers.inventoryLocations,
});

const mapDispatchToProps = (dispatch) => ({
  getInventoryLocations: (tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable) => dispatch(InventoryLocationActions.getInventoryLocations(tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable)),
});

WarehouseLocationSelector.propTypes = {
  user: PropTypes.any,
  destDepartmentId: PropTypes.any,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  containerClassName: PropTypes.any,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.string,
  getInventoryLocations: PropTypes.any,
  getInventoryLocationsLoading: PropTypes.bool,
  inventoryLocations: PropTypes.any,
  selectedInventoryLocation: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WarehouseLocationSelector));
